export const Roles = [
  {
    'roleName': 'Business Admin',
    'businessCategory': 'Provider',
    'value': [
      {
        component: 'BluBayDashboardComponent',
        route: 'landingpage',
        permission: {
          providersFlag: false, mealsImage: false, imageFlag: false, farmersCountFlag: false, businessAdminFarmCount: true,
          employeeFarmsCount: false, observationImage: false
        }
      },
      {
        component: 'LeftNavComponent',
        route: 'landingpage',
        permission: {
          dashboard: false,
          products: true,
          customers: true,
          peoples: true,
          fieldforce: true,
          metricsFalg: true,
          priceTickerUpload: false,
          metrics: {farm: [{pond: true, feed: true, treatments: true, harvest: true, waterquality: true, density: true, sampling: true, waterQualityHistory: true}]},
          adminPanel: {
            userSettingFalg: false,
            userSetting: [{
              route: false,
              feature: false,
              screen: false,
              sync: false,
              businessCategory: false,
              businessType: false,
              personCategory: false,
              personRole: false
            }],
            dmmFalg: true,
            dmm: [{onHand: false, deviceTracking: false, addDevice: false, assignDevice: true, monitoring: {deviceHealth: false}}],
            materialManagementFalg: false,
            materialManagement: [{transactionType: false, uom: false, shapes: false, itemType: false, product: false, vendorMaster: false}],
            hardWareFalg: false,
            hardWare: {
              deviceFalg: false, device: [{autoUpdate: false, wifi: false, fileUpload: false, fileDownload: false, ioPorts: false}],
              deviceModal: false, sensors: false, sensorType: false, deviceParameters: false
            },
            testConfigFalg: false,
            testConfiguration: [{qualityParameter: false, qualityParameterType: false, testCategories: false, qpRanges: false}],
            pondsFalg: false,
            pond: [{cultureCategory: false, waterType: false, soilType: false, speciesType: false, blindFeedSetting: false}],
            generalFalg: false,
            general: [{srStatusCode: false, serviceRequestTopic: false}],
            tradingCommunity: [{quickRegistration: false, businessEntiti: true, people: false}],
            addBarcode: false, serviceRequest: true, tankShift: false, orders: true
          },
          charts: {trendAnalysis: [{actualVsProjected: false, analystics: false}]},
          history: {waterQuality: true},
          reports: {
            farm: [{
              cultureSummary: true,
              pondSummary: true,
              daySummary: true,
              weeklyGrowth: false,
              treaceablityReport: true,
              materialMovementRegister: false,
              providerSummary: false,
              transactionRegister: false,
              paymentRegister: false,
              cultureEstimator: true
            }],
            staff: {activityTrackerLeads: true, activityTrackerLeadsCopy: true}
          },
          materialManagementFalg: false,
          materialManagement: {farmSpendAnalysis: false, materialTransaction: false, batchTransaction: false, paymentTransaction: false},
          continuousMonitoring: {cmlive: true}
        }
      },
      {
        component: 'ProductsComponent',
        route: 'products',
        permission: [{
          systemTypeFlag: false,
          businessFlag: false,
          farmFlag: false,
          searchDivFlag: true,
          farmBAdminSearchFlag: true,
          searchItem: false
        }]
      },
      {
        component: 'BusinessEntityFarmProviderComponent',
        route: 'BusinessEntityFarmsProvider/:id/:isAdmin',
        permission: [{bAdminBachBtn: false, businessDetails: false, addBusinessBtn: true, businessAdminCard: true}]
      },
      {
        component: 'BusinessEntityFarmsComponent',
        route: 'BusinessEntityFarms/:id/:isAdmin/:site/:actionType',
        permission: [{backToBusiness: false, smeContract: false, providerContract: false, buyerContract: false}]
      },
      {
        component: 'BusinessFarmfpFarmFarmsiteComponent',
        route: 'BusinessFP-Farm-Farmsite/:farmProviderid/:farmId/:isFarmsite',
        permission: [{siteButton: true}]
      },
      {
        component: 'PersonsListComponent',
        route: 'Persons-List/:isAdmin',
        permission: [{backButton: false, levels: true, personAll: false, spanTag: true, businessHide: true, businessNameDisp: true}]
      },
      {
        component: 'CultureSummaryComponent',
        route: 'culturesummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'PondSummaryComponent',
        route: 'pondsummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'DaySummaryComponent',
        route: 'daysummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'PondTracebilityComponent',
        route: 'traceabilityreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'ProviderSummaryReportComponent',
        route: 'providersummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialMovementRegisterComponent',
        route: 'mmregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'TransactionRegisterComponent',
        route: 'transactionregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionRegisterComponent',
        route: 'paymentregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'FarmSpendAnalyzerComponent',
        route: 'farmspendanalysis',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialTransactionComponent',
        route: 'materialtransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: false, BAdminName: true}]
      },
      {
        component: 'BatchEntryDashboardComponent',
        route: 'batchentrydashboard',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionComponent',
        route: 'paymenttransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {component: 'MultiplesrComponent', route: 'multiplesr', permission: [{edit: false, assign: false, status: false}]},
      {component: 'TankshiftComponent', route: 'tankshift', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'ProjectedFeedGraphComponent', route: 'projectedfeedgraph', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'AnalyticsComponent', route: 'analytics', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {
        component: 'WaterQualityHistoryComponent',
        route: 'historywaterquality',
        permission: [{employeeLogin: true, farmSelection: false, selectProvider: false, farmNameDisplay: false, siteSelection: false,}]
      },
    ],
  },
  {
    'roleName': 'Provider Manager',
    'businessCategory': 'Provider',
    'value': [
      {
        component: 'BluBayDashboardComponent',
        route: 'landingpage',
        permission: {
          providersFlag: false, mealsImage: false, imageFlag: false, farmersCountFlag: false, businessAdminFarmCount: true,
          employeeFarmsCount: false, observationImage: false
        }
      },
      {
        component: 'LeftNavComponent',
        route: 'landingpage',
        permission: {
          dashboard: false,
          products: false,
          customers: true,
          peoples: true,
          fieldforce: true,
          metricsFalg: true,
          priceTickerUpload: false,
          metrics: {farm: [{pond: true, feed: true, treatments: true, harvest: true, waterquality: true, density: true, sampling: true, waterQualityHistory: true}]},
          adminPanel: {
            userSettingFalg: false,
            userSetting: [{
              route: false,
              feature: false,
              screen: false,
              sync: false,
              businessCategory: false,
              businessType: false,
              personCategory: false,
              personRole: false
            }],
            dmmFalg: false,
            dmm: [{onHand: false, deviceTracking: false, addDevice: false, assignDevice: true, monitoring: {deviceHealth: false}}],
            materialManagementFalg: false,
            materialManagement: [{transactionType: false, uom: false, shapes: false, itemType: false, product: false, vendorMaster: false}],
            hardWareFalg: false,
            hardWare: {
              deviceFalg: false, device: [{autoUpdate: false, wifi: false, fileUpload: false, fileDownload: false, ioPorts: false}],
              deviceModal: false, sensors: false, sensorType: false, deviceParameters: false
            },
            testConfigFalg: false,
            testConfiguration: [{qualityParameter: false, qualityParameterType: false, testCategories: false, qpRanges: false}],
            pondsFalg: false,
            pond: [{cultureCategory: false, waterType: false, soilType: false, speciesType: false, blindFeedSetting: false}],
            generalFalg: false,
            general: [{srStatusCode: false, serviceRequestTopic: false}],
            tradingCommunity: [{quickRegistration: false, businessEntiti: false, people: false}],
            addBarcode: false, serviceRequest: false, tankShift: false, orders: true
          },
          charts: {trendAnalysis: [{actualVsProjected: false, analystics: false}]},
          history: {waterQuality: false},
          reports: {
            farm: [{
              cultureSummary: true,
              pondSummary: true,
              daySummary: true,
              weeklyGrowth: false,
              treaceablityReport: true,
              materialMovementRegister: false,
              providerSummary: false,
              transactionRegister: false,
              paymentRegister: false,
              cultureEstimator: true
            }],
            staff: {activityTrackerLeads: true, activityTrackerLeadsCopy: true}
          },
          materialManagementFalg: false,
          materialManagement: {farmSpendAnalysis: false, materialTransaction: false, batchTransaction: false, paymentTransaction: false},
          continuousMonitoring: {cmlive: false}
        }
      },
      {
        component: 'ProductsComponent',
        route: 'products',
        permission: [{
          systemTypeFlag: false,
          businessFlag: false,
          farmFlag: false,
          searchDivFlag: true,
          farmBAdminSearchFlag: true,
          searchItem: false
        }]
      },
      {
        component: 'BusinessEntityFarmProviderComponent',
        route: 'BusinessEntityFarmsProvider/:id/:isAdmin',
        permission: [{bAdminBachBtn: false, businessDetails: false, addBusinessBtn: true, businessAdminCard: true}]
      },
      {
        component: 'BusinessEntityFarmsComponent',
        route: 'BusinessEntityFarms/:id/:isAdmin/:site/:actionType',
        permission: [{backToBusiness: false, smeContract: false, providerContract: false, buyerContract: false}]
      },
      {
        component: 'BusinessFarmfpFarmFarmsiteComponent',
        route: 'BusinessFP-Farm-Farmsite/:farmProviderid/:farmId/:isFarmsite',
        permission: [{siteButton: false}]
      },
      {
        component: 'PersonsListComponent',
        route: 'Persons-List/:isAdmin',
        permission: [{backButton: false, levels: true, personAll: false, spanTag: true, businessHide: true, businessNameDisp: false}]
      },
      {
        component: 'CultureSummaryComponent',
        route: 'culturesummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: false, technicianPerson: true}]
      },
      {
        component: 'PondSummaryComponent',
        route: 'pondsummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: false, technicianPerson: true}]
      },
      {
        component: 'DaySummaryComponent',
        route: 'daysummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: false, technicianPerson: true}]
      },
      {
        component: 'PondTracebilityComponent',
        route: 'traceabilityreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: false, technicianPerson: true}]
      },
      {
        component: 'ProviderSummaryReportComponent',
        route: 'providersummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialMovementRegisterComponent',
        route: 'mmregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'TransactionRegisterComponent',
        route: 'transactionregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionRegisterComponent',
        route: 'paymentregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'FarmSpendAnalyzerComponent',
        route: 'farmspendanalysis',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialTransactionComponent',
        route: 'materialtransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: false, BAdminName: true}]
      },
      {
        component: 'BatchEntryDashboardComponent',
        route: 'batchentrydashboard',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionComponent',
        route: 'paymenttransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {component: 'MultiplesrComponent', route: 'multiplesr', permission: [{edit: false, assign: false, status: false}]},
      {component: 'TankshiftComponent', route: 'tankshift', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'ProjectedFeedGraphComponent', route: 'projectedfeedgraph', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'AnalyticsComponent', route: 'analytics', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {
        component: 'WaterQualityHistoryComponent',
        route: 'historywaterquality',
        permission: [{employeeLogin: true, farmSelection: false, selectProvider: false, farmNameDisplay: false, siteSelection: false,}]
      },
    ],
  },
  {
    'roleName': 'EMPLOYEE',
    'businessCategory': 'Others Category',
    'value': [
      {
        component: 'BluBayDashboardComponent',
        route: 'landingpage',
        permission: {
          providersFlag: true, mealsImage: false, imageFlag: false, farmersCountFlag: false, businessAdminFarmCount: false,
          employeeFarmsCount: true, observationImage: false
        }
      },
      {
        component: 'BusinessEntityFarmProviderComponent',
        route: 'BusinessEntityFarmsProvider/:id/:isAdmin',
        permission: [{bAdminBachBtn: true, businessDetails: true, addBusinessBtn: false, businessAdminCard: false}]
      },
      {
        component: 'BusinessEntityFarmsComponent',
        route: 'BusinessEntityFarms/:id/:isAdmin/:site/:actionType',
        permission: [{backToBusiness: true, smeContract: true, providerContract: true, buyerContract: true}]
      },
      {
        component: 'BusinessFarmfpFarmFarmsiteComponent',
        route: 'BusinessFP-Farm-Farmsite/:farmProviderid/:farmId/:isFarmsite',
        permission: [{siteButton: false}]
      },
      {
        component: 'PersonsListComponent',
        route: 'Persons-List/:isAdmin',
        permission: [{backButton: true, levels: false, personAll: true, businessHide: true, spanTag: true, businessNameDisp: false}]
      },
      {
        component: 'ProductsComponent',
        route: 'products',
        permission: [{
          systemTypeFlag: true,
          businessFlag: true,
          farmFlag: false,
          searchDivFlag: false,
          farmBAdminSearchFlag: false,
          searchItem: true
        }]
      },
      {
        component: 'LeftNavComponent',
        route: 'landingpage',
        permission: {
          dashboard: true,
          products: false,
          customers: false,
          fieldforce: false,
          metricsFalg: true,
          priceTickerUpload: true,
          metrics: {farm: [{pond: true, feed: true, treatments: true, harvest: true, waterquality: true, density: true, sampling: true, waterQualityHistory: true}]},
          adminPanel: {
            userSettingFalg: true,
            userSetting: [{
              route: true,
              feature: true,
              screen: true,
              sync: true,
              businessCategory: true,
              businessType: true,
              personCategory: true,
              personRole: true
            }],
            dmmFalg: true,
            dmm: [{onHand: true, deviceTracking: true, addDevice: true, assignDevice: true, monitoring: {deviceHealth: true}}],
            materialManagementFalg: true,
            materialManagement: [{transactionType: true, uom: true, shapes: true, itemType: true, product: true, vendorMaster: true}],
            hardWareFalg: true,
            hardWare: {
              deviceFalg: true, device: [{autoUpdate: true, wifi: true, fileUpload: true, fileDownload: true, ioPorts: true}],
              deviceModal: true, sensors: true, sensorType: true, deviceParameters: true
            },
            testConfigFalg: true,
            testConfiguration: [{qualityParameter: true, qualityParameterType: true, testCategories: true, qpRanges: true}],
            pondsFalg: true,
            pond: [{cultureCategory: true, waterType: true, soilType: true, speciesType: true, blindFeedSetting: true}],
            generalFalg: true,
            general: [{srStatusCode: true, serviceRequestTopic: true}],
            tradingCommunity: [{quickRegistration: true, businessEntiti: false, people: true}],
            addBarcode: true, serviceRequest: true, tankShift: true, orders: false
          },
          charts: {trendAnalysis: [{actualVsProjected: true, analystics: true}]},
          history: {waterQuality: true},
          reports: {
            farm: [{
              cultureSummary: true,
              pondSummary: true,
              daySummary: true,
              weeklyGrowth: true,
              treaceablityReport: true,
              materialMovementRegister: true,
              providerSummary: true,
              transactionRegister: true,
              paymentRegister: true,
              cultureEstimator: false
            }],
            staff: {activityTrackerLeads: true, activityTrackerLeadsCopy: false}
          },
          materialManagementFalg: true,
          materialManagement: {farmSpendAnalysis: true, materialTransaction: true, batchTransaction: true, paymentTransaction: true},
          continuousMonitoring: {cmlive: true}
        }
      },
      {
        component: 'CultureSummaryComponent',
        route: 'culturesummaryreport',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false, technicianPerson: false}]
      },
      {
        component: 'PondSummaryComponent',
        route: 'pondsummaryreport',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false, technicianPerson: false}]
      },
      {
        component: 'DaySummaryComponent',
        route: 'daysummary',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false, technicianPerson: false}]
      },
      {
        component: 'PondTracebilityComponent',
        route: 'traceabilityreport',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false, technicianPerson: false}]
      },
      {
        component: 'ProviderSummaryReportComponent',
        route: 'providersummary',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false}]
      },
      {
        component: 'MaterialMovementRegisterComponent',
        route: 'mmregister',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false}]
      },
      {
        component: 'TransactionRegisterComponent',
        route: 'transactionregister',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false}]
      },
      {
        component: 'PaymentTransactionRegisterComponent',
        route: 'paymentregister',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false}]
      },
      {
        component: 'FarmSpendAnalyzerComponent',
        route: 'farmspendanalysis',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false}]
      },
      {
        component: 'MaterialTransactionComponent',
        route: 'materialtransaction',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false, BAdminName: false}]
      },
      {
        component: 'BatchEntryDashboardComponent',
        route: 'batchentrydashboard',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false}]
      },
      {
        component: 'PaymentTransactionComponent',
        route: 'paymenttransaction',
        permission: [{excelButton: true, businessSelection: true, businessNameDisplay: false}]
      },
      {component: 'MultiplesrComponent', route: 'multiplesr', permission: [{edit: true, assign: true, status: true}]},
      {component: 'TankshiftComponent', route: 'tankshift', permission: [{farmSelection: true, farmNameDisplay: false}]},
      {component: 'ProjectedFeedGraphComponent', route: 'projectedfeedgraph', permission: [{farmSelection: true, farmNameDisplay: false}]},
      {component: 'AnalyticsComponent', route: 'analytics', permission: [{farmSelection: true, farmNameDisplay: false}]},
      {
        component: 'WaterQualityHistoryComponent',
        route: 'historywaterquality',
        permission: [{employeeLogin: true, farmSelection: false, selectProvider: true, farmNameDisplay: false, siteSelection: true,}]
      },
    ],
  },
  {
    'roleName': 'Business Admin',
    'businessCategory': 'Farm',
    'value': [
      {
        component: 'BluBayDashboardComponent',
        route: 'landingpage',
        permission: {
          providersFlag: false, mealsImage: true, imageFlag: true, farmersCountFlag: true, businessAdminFarmCount: false,
          employeeFarmsCount: false, observationImage: true
        }
      },
      {
        component: 'BusinessEntityFarmProviderComponent',
        route: 'BusinessEntityFarmsProvider/:id/:isAdmin',
        permission: [{bAdminBachBtn: true, businessDetails: true, addBusinessBtn: false, businessAdminCard: false}]
      },
      {
        component: 'BusinessEntityFarmsComponent',
        route: 'BusinessEntityFarms/:id/:isAdmin/:site/:actionType',
        permission: [{backToBusiness: false, smeContract: true, providerContract: true, buyerContract: true}]
      },
      {
        component: 'BusinessFarmfpFarmFarmsiteComponent',
        route: 'BusinessFP-Farm-Farmsite/:farmProviderid/:farmId/:isFarmsite',
        permission: [{siteButton: false}]
      },
      {
        component: 'PersonsListComponent',
        route: 'Persons-List/:isAdmin',
        permission: [{backButton: true, levels: false, personAll: true, businessHide: false, spanTag: false, businessNameDisp: true}]
      },
      {
        component: 'LeftNavComponent',
        route: 'landingpage',
        permission: {
          dashboard: true,
          products: false,
          customers: false,
          fieldforce: false,
          metricsFalg: true,
          priceTickerUpload: false,
          metrics: {farm: [{pond: true, feed: true, treatments: true, harvest: true, waterquality: true, density: true, sampling: true, waterQualityHistory: true}]},
          adminPanel: {
            userSettingFalg: false,
            userSetting: [{
              route: false,
              feature: false,
              screen: false,
              sync: false,
              businessCategory: false,
              businessType: false,
              personCategory: false,
              personRole: false
            }],
            dmmFalg: false,
            dmm: [{onHand: false, deviceTracking: false, addDevice: false, assignDevice: false, monitoring: {deviceHealth: false}}],
            materialManagementFalg: true,
            materialManagement: [{transactionType: false, uom: false, shapes: false, itemType: false, product: true, vendorMaster: true}],
            hardWareFalg: false,
            hardWare: {
              deviceFalg: false, device: [{autoUpdate: false, wifi: false, fileUpload: false, fileDownload: false, ioPorts: false}],
              deviceModal: false, sensors: false, sensorType: false, deviceParameters: false
            },
            testConfigFalg: false,
            testConfiguration: [{qualityParameter: false, qualityParameterType: false, testCategories: false, qpRanges: false}],
            pondsFalg: false,
            pond: [{cultureCategory: false, waterType: false, soilType: false, speciesType: false, blindFeedSetting: false}],
            generalFalg: false,
            general: [{srStatusCode: false, serviceRequestTopic: false}],
            tradingCommunity: [{quickRegistration: false, businessEntiti: true, people: true}],
            addBarcode: false, serviceRequest: true, tankShift: true, orders: false
          },
          charts: {trendAnalysis: [{actualVsProjected: true, analystics: true}]},
          history: {waterQuality: true},
          reports: {
            farm: [{
              cultureSummary: true,
              pondSummary: true,
              daySummary: true,
              weeklyGrowth: true,
              treaceablityReport: true,
              materialMovementRegister: true,
              providerSummary: false,
              transactionRegister: true,
              paymentRegister: true,
              cultureEstimator: true
            }],
            staff: {activityTrackerLeads: false, activityTrackerLeadsCopy: false}
          },
          materialManagementFalg: true,
          materialManagement: {farmSpendAnalysis: true, materialTransaction: true, batchTransaction: true, paymentTransaction: true},
          continuousMonitoring: {cmlive: true}
        }
      },
      {
        component: 'ProductsComponent',
        route: 'products',
        permission: [{
          systemTypeFlag: false,
          businessFlag: false,
          farmFlag: true,
          searchItem: false,
          searchDivFlag: false,
          farmBAdminSearchFlag: true,
        }]
      },
      {
        component: 'CultureSummaryComponent',
        route: 'culturesummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'PondSummaryComponent',
        route: 'pondsummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'DaySummaryComponent',
        route: 'daysummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'PondTracebilityComponent',
        route: 'traceabilityreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'ProviderSummaryReportComponent',
        route: 'providersummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialMovementRegisterComponent',
        route: 'mmregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'TransactionRegisterComponent',
        route: 'transactionregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionRegisterComponent',
        route: 'paymentregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'FarmSpendAnalyzerComponent',
        route: 'farmspendanalysis',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialTransactionComponent',
        route: 'materialtransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, BAdminName: false}]
      },
      {
        component: 'BatchEntryDashboardComponent',
        route: 'batchentrydashboard',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionComponent',
        route: 'paymenttransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {component: 'MultiplesrComponent', route: 'multiplesr', permission: [{edit: false, assign: false, status: false}]},
      {component: 'TankshiftComponent', route: 'tankshift', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'ProjectedFeedGraphComponent', route: 'projectedfeedgraph', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'AnalyticsComponent', route: 'analytics', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {
        component: 'WaterQualityHistoryComponent',
        route: 'historywaterquality',
        permission: [{employeeLogin: false, farmSelection: true, selectProvider: true, siteSelection: false, farmNameDisplay: true}]
      },
    ],
  },
  {
    'roleName': 'Farmer',
    'businessCategory': 'Farm',
    'value': [
      {
        component: 'BluBayDashboardComponent',
        route: 'landingpage',
        permission: {
          providersFlag: false, mealsImage: true, imageFlag: true, farmersCountFlag: true, businessAdminFarmCount: false,
          employeeFarmsCount: false, observationImage: true
        }
      },
      {
        component: 'BusinessEntityFarmProviderComponent',
        route: 'BusinessEntityFarmsProvider/:id/:isAdmin',
        permission: [{bAdminBachBtn: true, businessDetails: true, addBusinessBtn: false, businessAdminCard: false}]
      },
      {
        component: 'BusinessEntityFarmsComponent',
        route: 'BusinessEntityFarms/:id/:isAdmin/:site/:actionType',
        permission: [{backToBusiness: false, smeContract: true, providerContract: true, buyerContract: true}]
      },
      {
        component: 'BusinessFarmfpFarmFarmsiteComponent',
        route: 'BusinessFP-Farm-Farmsite/:farmProviderid/:farmId/:isFarmsite',
        permission: [{siteButton: false}]
      },
      {
        component: 'PersonsListComponent',
        route: 'Persons-List/:isAdmin',
        permission: [{backButton: true, levels: false, personAll: true, businessHide: false, spanTag: false, businessNameDisp: true}]
      },
      {
        component: 'LeftNavComponent',
        route: 'landingpage',
        permission: {
          dashboard: true,
          products: false,
          customers: false,
          fieldforce: false,
          metricsFalg: true,
          priceTickerUpload: false,
          metrics: {farm: [{pond: true, feed: true, treatments: true, harvest: true, waterquality: true, density: true, sampling: true, waterQualityHistory: true}]},
          adminPanel: {
            userSettingFalg: false,
            userSetting: [{
              route: false,
              feature: false,
              screen: false,
              sync: false,
              businessCategory: false,
              businessType: false,
              personCategory: false,
              personRole: false
            }],
            dmmFalg: false,
            dmm: [{onHand: false, deviceTracking: false, addDevice: false, assignDevice: false, monitoring: {deviceHealth: false}}],
            materialManagementFalg: true,
            materialManagement: [{transactionType: false, uom: false, shapes: false, itemType: false, product: true, vendorMaster: true}],
            hardWareFalg: false,
            hardWare: {
              deviceFalg: false, device: [{autoUpdate: false, wifi: false, fileUpload: false, fileDownload: false, ioPorts: false}],
              deviceModal: false, sensors: false, sensorType: false, deviceParameters: false
            },
            testConfigFalg: false,
            testConfiguration: [{qualityParameter: false, qualityParameterType: false, testCategories: false, qpRanges: false}],
            pondsFalg: false,
            pond: [{cultureCategory: false, waterType: false, soilType: false, speciesType: false, blindFeedSetting: false}],
            generalFalg: false,
            general: [{srStatusCode: false, serviceRequestTopic: false}],
            tradingCommunity: [{quickRegistration: false, businessEntiti: true, people: true}],
            addBarcode: false, serviceRequest: true, tankShift: true, orders: false
          },
          charts: {trendAnalysis: [{actualVsProjected: true, analystics: true}]},
          history: {waterQuality: true},
          reports: {
            farm: [{
              cultureSummary: true,
              pondSummary: true,
              daySummary: true,
              weeklyGrowth: true,
              treaceablityReport: true,
              materialMovementRegister: true,
              providerSummary: false,
              transactionRegister: true,
              paymentRegister: true,
              cultureEstimator: true
            }],
            staff: {activityTrackerLeads: false, activityTrackerLeadsCopy: false}
          },
          materialManagementFalg: true,
          materialManagement: {farmSpendAnalysis: true, materialTransaction: true, batchTransaction: true, paymentTransaction: true},
          continuousMonitoring: {cmlive: true}
        }
      },
      {
        component: 'ProductsComponent',
        route: 'products',
        permission: [{
          systemTypeFlag: false,
          businessFlag: false,
          farmFlag: true,
          searchItem: false,
          searchDivFlag: false,
          farmBAdminSearchFlag: true,
        }]
      },
      {
        component: 'CultureSummaryComponent',
        route: 'culturesummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'PondSummaryComponent',
        route: 'pondsummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'DaySummaryComponent',
        route: 'daysummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'PondTracebilityComponent',
        route: 'traceabilityreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'ProviderSummaryReportComponent',
        route: 'providersummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialMovementRegisterComponent',
        route: 'mmregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'TransactionRegisterComponent',
        route: 'transactionregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionRegisterComponent',
        route: 'paymentregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'FarmSpendAnalyzerComponent',
        route: 'farmspendanalysis',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialTransactionComponent',
        route: 'materialtransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, BAdminName: false}]
      },
      {
        component: 'BatchEntryDashboardComponent',
        route: 'batchentrydashboard',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionComponent',
        route: 'paymenttransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {component: 'MultiplesrComponent', route: 'multiplesr', permission: [{edit: false, assign: false, status: false}]},
      {component: 'TankshiftComponent', route: 'tankshift', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'ProjectedFeedGraphComponent', route: 'projectedfeedgraph', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'AnalyticsComponent', route: 'analytics', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {
        component: 'WaterQualityHistoryComponent',
        route: 'historywaterquality',
        permission: [{employeeLogin: false, farmSelection: true, selectProvider: true, siteSelection: false, farmNameDisplay: true}]
      },
    ],
  },
  {
    'roleName': 'Farm Manager',
    'businessCategory': 'Farm',
    'value': [
      {
        component: 'BluBayDashboardComponent',
        route: 'landingpage',
        permission: {
          providersFlag: true, mealsImage: true, imageFlag: false, farmersCountFlag: true, businessAdminFarmCount: false,
          employeeFarmsCount: false, observationImage: true
        }
      },
      {
        component: 'BusinessEntityFarmProviderComponent',
        route: 'BusinessEntityFarmsProvider/:id/:isAdmin',
        permission: [{bAdminBachBtn: true, businessDetails: true, addBusinessBtn: false, businessAdminCard: false}]
      },
      {
        component: 'BusinessEntityFarmsComponent',
        route: 'BusinessEntityFarms/:id/:isAdmin/:site/:actionType',
        permission: [{backToBusiness: false, smeContract: true, providerContract: true, buyerContract: true}]
      },
      {
        component: 'BusinessFarmfpFarmFarmsiteComponent',
        route: 'BusinessFP-Farm-Farmsite/:farmProviderid/:farmId/:isFarmsite',
        permission: [{siteButton: false}]
      },
      {
        component: 'PersonsListComponent',
        route: 'Persons-List/:isAdmin',
        permission: [{backButton: true, levels: false, personAll: true, businessHide: false, spanTag: false, businessNameDisp: true}]
      },
      {component: 'MultiplesrComponent', route: 'multiplesr', permission: [{edit: false, assign: false, status: false}]},
      {
        component: 'LeftNavComponent',
        route: 'landingpage',
        permission: {
          dashboard: true,
          products: false,
          customers: false,
          fieldforce: false,
          metricsFalg: true,
          priceTickerUpload: false,
          metrics: {farm: [{pond: true, feed: true, treatments: true, harvest: true, waterquality: true, density: true, sampling: true, waterQualityHistory: true}]},
          adminPanel: {
            userSettingFalg: false,
            userSetting: [{
              route: false,
              feature: false,
              screen: false,
              sync: false,
              businessCategory: false,
              businessType: false,
              personCategory: false,
              personRole: false
            }],
            dmmFalg: false,
            dmm: [{onHand: false, deviceTracking: false, addDevice: false, assignDevice: false, monitoring: {deviceHealth: false}}],
            materialManagementFalg: true,
            materialManagement: [{transactionType: false, uom: false, shapes: false, itemType: false, product: true, vendorMaster: true}],
            hardWareFalg: false,
            hardWare: {
              deviceFalg: false, device: [{autoUpdate: false, wifi: false, fileUpload: false, fileDownload: false, ioPorts: false}],
              deviceModal: false, sensors: false, sensorType: false, deviceParameters: false
            },
            testConfigFalg: false,
            testConfiguration: [{qualityParameter: false, qualityParameterType: false, testCategories: false, qpRanges: false}],
            pondsFalg: false,
            pond: [{cultureCategory: false, waterType: false, soilType: false, speciesType: false, blindFeedSetting: false}],
            generalFalg: false,
            general: [{srStatusCode: false, serviceRequestTopic: false}],
            tradingCommunity: [{quickRegistration: false, businessEntiti: true, people: true}],
            addBarcode: false, serviceRequest: true, tankShift: true, orders: false
          },
          charts: {trendAnalysis: [{actualVsProjected: true, analystics: true}]},
          history: {waterQuality: true},
          reports: {
            farm: [{
              cultureSummary: true,
              pondSummary: true,
              daySummary: true,
              weeklyGrowth: true,
              treaceablityReport: true,
              materialMovementRegister: true,
              providerSummary: false,
              transactionRegister: true,
              paymentRegister: true,
              cultureEstimator: true
            }],
            staff: {activityTrackerLeads: false, activityTrackerLeadsCopy: false}
          },
          materialManagementFalg: true,
          materialManagement: {farmSpendAnalysis: true, materialTransaction: true, batchTransaction: true, paymentTransaction: true},
          continuousMonitoring: {cmlive: true}
        }
      },
      {
        component: 'ProductsComponent',
        route: 'products',
        permission: [{
          systemTypeFlag: false,
          businessFlag: false,
          farmFlag: true,
          farmBAdminSearchFlag: false,
          searchDivFlag: false,
          searchItem: true
        }]
      },
      {
        component: 'CultureSummaryComponent',
        route: 'culturesummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'PondSummaryComponent',
        route: 'pondsummaryreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'DaySummaryComponent',
        route: 'daysummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'PondTracebilityComponent',
        route: 'traceabilityreport',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, technicianPerson: false}]
      },
      {
        component: 'ProviderSummaryReportComponent',
        route: 'providersummary',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialMovementRegisterComponent',
        route: 'mmregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'TransactionRegisterComponent',
        route: 'transactionregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionRegisterComponent',
        route: 'paymentregister',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'FarmSpendAnalyzerComponent',
        route: 'farmspendanalysis',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'MaterialTransactionComponent',
        route: 'materialtransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true, BAdminName: false}]
      },
      {
        component: 'BatchEntryDashboardComponent',
        route: 'batchentrydashboard',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {
        component: 'PaymentTransactionComponent',
        route: 'paymenttransaction',
        permission: [{excelButton: true, businessSelection: false, businessNameDisplay: true}]
      },
      {component: 'MultiplesrComponent', route: 'multiplesr', permission: [{edit: false, assign: false, status: false}]},
      {component: 'TankshiftComponent', route: 'tankshift', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'ProjectedFeedGraphComponent', route: 'projectedfeedgraph', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {component: 'AnalyticsComponent', route: 'analytics', permission: [{farmSelection: false, farmNameDisplay: true}]},
      {
        component: 'WaterQualityHistoryComponent',
        route: 'historywaterquality',
        permission: [{employeeLogin: false, farmSelection: true, selectProvider: true, siteSelection: false, farmNameDisplay: true}]
      },
    ],
  },
];
